import { useEffect, useState } from "react";
import { useBlockUI } from "../../../shared/services/block-ui-service";
import instance from "../../index";
import { BaseResponse } from "../../../models/base-response";
import { PagedList } from "../../../models/paged-list";
import { ShortDto } from "../../../models/short-dto";
import {CreateReferenceGroupRequest} from "../../../models/requests/create-reference-group-request";
import {ReferenceGroupFilters} from "../../../filters/reference-group-filters";
import {UpdateReferenceGroupRequest} from "../../../models/requests/update-reference-group-request";
import {ReferenceGroup} from "../../../models/fleet-type";


const useReferenceGroupService = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const blockUI = useBlockUI();

    useEffect(() => {
        blockUI?.setActive(loading);
    }, [loading]);

    async function createReferenceGroup(request: Partial<CreateReferenceGroupRequest>) {
        const response = await instance.post("/v1/backoffice/reference-groups", request);
        return response.data;
    }

    async function activateReferenceGroup(id: string) {
        const response = await instance.put(`/v1/backoffice/reference-groups/${id}/activate`);
        return response.data;
    }

    async function deactivateReferenceGroup(id: string) {
        const response = await instance.put(`/v1/backoffice/reference-groups/${id}/deactivate`);
        return response.data;
    }

    async function getReferenceGroups(filter?: ReferenceGroupFilters): Promise<PagedList<ReferenceGroup>> {
        const response = await instance.get<BaseResponse<PagedList<ReferenceGroup>>>("/v1/backoffice/reference-groups", { params: filter });
        return response.data.data;
    }

    async function getReferenceGroupById(id: string) {
        const response = await instance.get<BaseResponse<ReferenceGroup>>(`/v1/backoffice/reference-groups/${id}`);
        return response?.data?.data;
    }

    async function updateReferenceGroup(id: string, request: Partial<UpdateReferenceGroupRequest>) {
        const response = await instance.put(`/v1/backoffice/reference-groups/${id}`, request);
        return response.data;
    }

    async function deleteReferenceGroup(id: string) {
        const response = await instance.delete(`/v1/backoffice/reference-groups/${id}`);
        return response?.data;
    }

    async function getReferenceGroupsShort(): Promise<ShortDto[]> {
        const response = await instance.get<BaseResponse<ShortDto[]>>("/v1/backoffice/reference-groups/short");
        return response?.data?.data;
    }

    return {
        loading,
        createReferenceGroup,
        activateReferenceGroup,
        deactivateReferenceGroup,
        getReferenceGroups,
        getReferenceGroupById,
        updateReferenceGroup,
        deleteReferenceGroup,
        getReferenceGroupsShort
    };
};

export default useReferenceGroupService;
